import { ActiveValueType, SeverityScore, ValueType } from "pokal_api"

function severityToString(
    severityScore: SeverityScore,
    type: ActiveValueType
): string {
    const questionnaireSeverities: string[] = [
        "Keine",
        "Minimal",
        "Mild",
        "Leicht",
        "Mittel",
        "Schwer"
    ]
    const moodSeverities: string[] = [
        "Sehr schlecht",
        "Nicht gut",
        "Neutral",
        "Gut",
        "Sehr Gut"
    ]
    switch (type) {
        case ValueType.MOOD:
            switch (severityScore) {
                case 5:
                    throw "Bad mood severity score."
                default:
                    return moodSeverities[severityScore]
            }
        case ValueType.PHQUESTIONNAIRE:
            switch (severityScore) {
                default:
                    return questionnaireSeverities[severityScore]
            }
        case ValueType.SFQUESTIONNAIRE:
            switch (severityScore) {
                default:
                    return questionnaireSeverities[severityScore]
            }
    }
}

export default severityToString
